export { getDynamicConfig } from "./get-dynamic-config";
export type {
    GetDynamicConfigOptions,
    DynamicConfigValueType
} from "./get-dynamic-config";
